import '../sass/project.scss';

import {createApp} from 'vue/dist/vue.esm-bundler';
import { components } from './components/index.js';
import { initAllCommentEditors } from './tiptap-editor.js';

// Initialize Vue apps on page load
document.addEventListener('DOMContentLoaded', function() {
    // Mount Vue apps for elements with data-vue-app attribute
    const vueElements = document.querySelectorAll('[data-vue-app]');
    
    vueElements.forEach(element => {
        const app = createApp({
            components: components
        });
        app.mount(element);
    });
    
    // Initialize Tiptap editors
    initAllCommentEditors();
});


window.onload = () => {

    var modals_to_open = document.querySelectorAll('.modal_auto_open');
    modals_to_open.forEach(function (modal) {
        const myModal = new bootstrap.Modal(modal);
        myModal.show();
    });

}
window.initCompanyAutocomplete = function(inputId, resultsId, websiteId, logoUrlId, selectedCompanyId) {
    const input = document.getElementById(inputId);
    const resultsDiv = document.getElementById(resultsId);
    const websiteInput = document.getElementById(websiteId);
    const logoUrlInput = document.getElementById(logoUrlId);
    const selectedCompanyDiv = document.getElementById(selectedCompanyId);

    let debounceTimer;

    input.addEventListener('input', function() {
      //we sanitize the input value here, so we dont render malicious code and html
      const query = input.value; 
    
      // Clear the previous timer
      clearTimeout(debounceTimer);

      // Clear selected company when input changes
      if (selectedCompanyDiv) {
        selectedCompanyDiv.innerHTML = '';
      }
      
      // Debounce the API call by 250ms
      debounceTimer = setTimeout(function() {
        if (query.length > 2) {
          fetch(`/api/v1/company-autocomplete/?query=${query}`)
            .then(response => response.json())
            .then(data => displayResults(data))
            .catch(error => console.error('Error fetching data:', error));
        } else {
          resultsDiv.innerHTML = '';
        }
      }, 250);
    });
  
    function displayResults(data) {
      resultsDiv.innerHTML = '';
  
      data.forEach(company => {
        const resultItem = document.createElement('div');
        resultItem.classList.add('border', 'rounded-lg', 'p-4', 'mb-3', 'hover:bg-gray-50', 'cursor-pointer', 'transition-colors');
        resultItem.innerHTML = `   
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <img src="${company.logo}" class="w-12 h-12 object-contain" alt="${company.name}" />
              <div>
                <span class="font-medium text-gray-900 hover:text-blue-600">${company.name}</span>
                <span class="text-gray-500">(${company.domain})</span>
              </div>
            </div>
          </div>
        `;
        resultItem.addEventListener('click', () => {
          input.value = company.name;
          websiteInput.value = 'https://' + company.domain;
          logoUrlInput.value = company.logo;
          resultsDiv.innerHTML = '';
          
          // Display selected company info
          if (selectedCompanyDiv) {
            selectedCompanyDiv.innerHTML = `
              <div class="p-4 bg-green-50 border border-green-200 rounded-lg flex items-center gap-3">
                <img src="${company.logo}" class="w-12 h-12 object-contain" alt="${company.name}" />
                <div>
                  <div class="font-medium text-gray-900 mb-1">${company.name}</div>
                  <div class="text-green-600 text-sm">${company.domain}</div>
                </div>
              </div>
            `;
          }
        });
  
        resultsDiv.appendChild(resultItem);
      });



    const createWithoutAutocompleteItem = document.createElement('div');
    
    createWithoutAutocompleteItem.classList.add('border', 'border-dashed', 'rounded-lg', 'p-4', 'mb-3', 'bg-gray-50', 'hover:bg-gray-100', 'cursor-pointer', 'transition-colors');
    createWithoutAutocompleteItem.innerHTML = `
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-700">
            Not seeing the right <span class="font-medium">${input.value}</span>?<br>
            Click here to create it and add the website later.
          </p>
        </div>
      </div>
    `;

    createWithoutAutocompleteItem.addEventListener('click', () => {
      websiteInput.value = '';
      logoUrlInput.value = '';
      resultsDiv.innerHTML = '';
      
      // Display selected company info
      if (selectedCompanyDiv) {
        selectedCompanyDiv.innerHTML = `
          <div class="p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-600 mt-1" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <div>
              <div class="font-medium text-gray-900 mb-1">${input.value}</div>
              <div class="text-gray-500 text-sm">You can select this company, but you will need to fill their website later on.</div>
            </div>
          </div>
        `;
      }
    });

      resultsDiv.appendChild(createWithoutAutocompleteItem);
    }
  }

// Handle background images through data attributes (for Tailwind migration)
document.addEventListener('DOMContentLoaded', function() {
  const avatarBgElements = document.querySelectorAll('.avatar-bg[data-bg-url]');
  avatarBgElements.forEach(function(el) {
    const bgUrl = el.getAttribute('data-bg-url');
    if (bgUrl) {
      el.style.backgroundImage = `url('${bgUrl}')`;
    }
  });
});

/**
 * Initialize a custom multi-select component
 * @param {string} toggleId - ID of the "Select All" toggle button
 * @param {string} name - The input name attribute to match for checkboxes
 * @param {Object} options - Optional configuration
 * @param {Function} options.onChange - Optional callback when selection changes
 */
window.initCustomMultiSelect = function(toggleId, name, options = {}) {
  const toggleButton = document.getElementById(toggleId);
  if (!toggleButton) return;
  
  const checkboxes = document.querySelectorAll(`input[name="${name}"]`);
  if (!checkboxes.length) return;
  
  // Initial state check
  function updateToggleText() {
    const allChecked = Array.from(checkboxes).every(cb => cb.checked);
    toggleButton.textContent = allChecked ? 'Deselect All' : 'Select All';
    
    // If onChange callback is provided, call it with the selected values
    if (options.onChange && typeof options.onChange === 'function') {
      const selectedValues = Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);
      
      options.onChange(selectedValues);
    }
  }
  
  // Initialize toggle text
  updateToggleText();
  
  // Add click handler for toggle button
  toggleButton.addEventListener('click', function() {
    const allChecked = Array.from(checkboxes).every(cb => cb.checked);
    
    checkboxes.forEach(checkbox => {
      checkbox.checked = !allChecked;
    });
    
    updateToggleText();
  });
  
  // Add change handlers for individual checkboxes
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateToggleText);
  });
  
  // Return methods for programmatic control
  return {
    selectAll: function() {
      checkboxes.forEach(checkbox => { checkbox.checked = true; });
      updateToggleText();
    },
    deselectAll: function() {
      checkboxes.forEach(checkbox => { checkbox.checked = false; });
      updateToggleText();
    },
    getSelectedValues: function() {
      return Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);
    }
  };
};

/**
 * Open Crisp chat with custom message, fallback to redirect if API fails
 * @param {string} message - Custom message to send to Crisp chat
 */
window.openCrispChat = function(message = 'Hi! I have questions about choosing the right plan or need a custom plan for my team.') {
  try {
    // Check if Crisp is available
    if (typeof $crisp !== 'undefined' && $crisp && typeof $crisp.push === 'function') {
      // Try to set message and open chat
      $crisp.is("chat:opened");
      $crisp.push(['set', 'message:text', [message]]);
      $crisp.push(['do', 'chat:open']);
    } else {
      // Crisp not available, redirect
      throw new Error('Crisp not available');
    }
  } catch (error) {
    console.warn('Failed to open Crisp chat via API:', error);
    // Fallback: redirect to Crisp chat URL
    window.location.href = 'https://go.crisp.chat/chat/embed/?website_id=06f14b7d-23ba-4e46-882d-4e421b8a7582';
  }
};

